module.exports = __webpack_public_path__ + "media/src/images/app_icons/favicons/ms-icon-310x310-5ee403d3b39e23ee43341c4184ac9dfb.png";